import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileActionBar from "./MobileActionBar";
import CookieBanner from "./CookieBanner";
import SeoSchema from "./SeoSchema";
import ReserveSticky from "./ReserveSticky";

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#050505] text-[#F8F5EF] flex flex-col" data-testid="site-layout">
      <SeoSchema />
      <Header />
      <ReserveSticky />
      <main className="flex-1 pb-20 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileActionBar />
      <CookieBanner />
    </div>
  );
}
